import { takeEvery } from 'redux-saga/effects';

import { BADGE_USER_DETAILS } from 'actions/badge.actions';
import { getBadgeUserDetailsSaga } from 'sagas/badge.saga';
import { REQUEST } from 'services/api';

export function* getBadgeUserDetailsSagaWatcher(): unknown {
  yield takeEvery(BADGE_USER_DETAILS[REQUEST], getBadgeUserDetailsSaga);
}
